import { render, staticRenderFns } from "./TheoryTab.vue?vue&type=template&id=3d7eaad4"
import script from "./TheoryTab.vue?vue&type=script&lang=js"
export * from "./TheoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports